import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      {/* Background elements */}
      <div className="hero-background">
        <div className="gradient-background"></div>
        
        {/* Network diagram using the banner.svg */}
        <div className="network-diagram">
          <img src="/banner.svg" alt="Network Diagram" className="network-svg" />
        </div>
      </div>
      
      {/* Left side: Text content */}
      <div className="hero-content">
        <h1 className="hero-title">NRTR</h1>
        <p className="hero-subtitle">Take control of your network</p>
        <div className="hero-actions">
          <button className="btn-black">
            Get for free
          </button>
          <button className="btn-outline">
            Learn more
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      
      {/* Right side: Image/diagram space */}
      <div className="hero-image-side">
        {/* The background and diagram are positioned absolutely and will appear here */}
      </div>
    </section>
  );
};

export default Hero; 